export default "__VITE_ASSET__FZO9JLEZ__"